<template>
  <div class="c-about media" :class="ArticleFormat + ' ' + pageLoaded">
    <main-menu />
    <blog-detail :data="ArticleData"></blog-detail>
    <section-blog id="thought" :data="blogDataA"></section-blog>
    <footer-container></footer-container>
  </div>
</template>

<script>
import MainMenu from '@/components/MainMenu'
import BlogDetail from '@/components/BlogDetail'
import FooterContainer from '@/components/FooterContainer'
import SectionBlog from '@/views/SectionBlog'

export default {
  data () {
    return {
      isLoaded: false
    }
  },
  computed: {
    ArticleData () {
      let data = {}
      // console.log(this.$route.params.id)
      // console.log(this.$store.state.ProductArticle.articles.workimage)
      const dataId = parseInt(this.$route.params.id, 10)
      // console.log('dataId: ', dataId)
      // console.log('post.id: ', this.$store.state.BlogArticle.articles)
      if (this.$store.state.BlogArticle.articles !== undefined) {
        data = this.$store.state.BlogArticle.articles.find(post => (post.id === dataId))
      }
      return data
    },
    ArticleFormat () {
      let format = 'standard'
      const dataId = parseInt(this.$route.params.id, 10)
      // console.log('dataId: ', dataId)
      // console.log('post.id: ', this.$store.state.BlogArticle.articles)
      if (this.$store.state.BlogArticle.articles !== undefined) {
        format = this.$store.state.BlogArticle.articles.find(post => (post.id === dataId)).format
      }
      return format
    },
    pageLoaded () {
      return 'loaded'
    },
    blogDataA () {
      return this.$store.state.BlogArticle.articles
    }
  },
  mounted () {
    this.isLoaded = true
    document.body.classList.remove('thought-white')
  },
  components: {
    MainMenu,
    BlogDetail,
    FooterContainer,
    SectionBlog
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Blog.vue